import React from "react";
import { Badge } from "react-bootstrap";

import classes from "./AdviceStatusBadge.module.css";
import { CPVO_EXPERT_ADVICE_STATUS, CPVO_EXPERT_ADVICE_STATUS_TEXT } from "../../../shared/utility";
import { useTranslation } from "react-i18next";

const AdviceStatusBadge = (props: any) => {
  const { t } = useTranslation();

  let {
    id,
    text
  } = props;

  if (text) {
    switch (text) {
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.NOT_REQUESTED:
        id = CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.REQUESTED:
        id = CPVO_EXPERT_ADVICE_STATUS.REQUESTED;
         break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.PENDING_ANALYSIS:
        id = CPVO_EXPERT_ADVICE_STATUS.PENDING_ANALYSIS;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.PENDING_COMMITTEE:
        id = CPVO_EXPERT_ADVICE_STATUS.PENDING_COMMITTEE;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.NO_OBSERVATION:
        id = CPVO_EXPERT_ADVICE_STATUS.NO_OBSERVATION;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.OBSERVATION:
        id = CPVO_EXPERT_ADVICE_STATUS.OBSERVATION;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.CANCELLED:
        id = CPVO_EXPERT_ADVICE_STATUS.CANCELLED;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.CONDITION:
        id = CPVO_EXPERT_ADVICE_STATUS.CONDITION;
        break;
      case CPVO_EXPERT_ADVICE_STATUS_TEXT.PRIOR_RIGHT:
        id = CPVO_EXPERT_ADVICE_STATUS.PRIOR_RIGHT;
        break;
      default:
        id = -1;
        break;
    }
  }

  const getRequestAdviceClass = (adviceId: any) => {
    const classArray = [classes.badge];
    switch (adviceId) {
      case CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED:
        classArray.push(classes.badgeNotRequested);
        break;
        case CPVO_EXPERT_ADVICE_STATUS.REQUESTED:
        classArray.push(classes.badgeRequested);
         break;
      case CPVO_EXPERT_ADVICE_STATUS.PENDING_ANALYSIS:
        classArray.push(classes.badgePendingAnalysis);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.PENDING_COMMITTEE:
        classArray.push(classes.badgePendingCommittee);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.NO_OBSERVATION:
        classArray.push(classes.badgeNoObservation);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.OBSERVATION:
        classArray.push(classes.badgeObservation);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.CANCELLED:
        classArray.push(classes.badgeCancelled);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.CONDITION:
        classArray.push(classes.badgeCondition);
        break;
      case CPVO_EXPERT_ADVICE_STATUS.PRIOR_RIGHT:
        classArray.push(classes.badgePriorRight);
        break;
      default:
        classArray.push(classes.badgeNotRequested);
        break;
    }

    return classArray.join(" ");
  }

  const getRequestAdviceText = (adviceId: any, text: any) => {
    let adviceText = "";
    switch (adviceId) {
      case CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED:
        adviceText = t("advice_status.not_requested");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.REQUESTED:
        adviceText = t("advice_status.requested");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.PENDING_ANALYSIS:
        adviceText = t("advice_status.pending_analysis");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.PENDING_COMMITTEE:
        adviceText = t("advice_status.pending_committee");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.NO_OBSERVATION:
        adviceText = t("advice_status.no_observation");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.OBSERVATION:
        adviceText = t("advice_status.observation");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.CANCELLED:
        adviceText = t("advice_status.cancelled");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.CONDITION:
        adviceText = t("advice_status.condition");
        break;
      case CPVO_EXPERT_ADVICE_STATUS.PRIOR_RIGHT:
        adviceText = t("advice_status.prior_right");
        break;
      default:
        adviceText = text || t("advice_status.not_requested");
        break;
    }

    return adviceText;
  }

  return (
    id !== CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED ?
      <Badge className={getRequestAdviceClass(id)}>
        {getRequestAdviceText(id, text)}
      </Badge>
    : <></>
  );
}

export default AdviceStatusBadge;
